import React, { useEffect, useState } from 'react';
import { useClickAway } from 'react-use';
import { useEditorStore } from './editor-store';

type Props = {
  children: React.ReactNode;
  style: {
    [key: string]: string;
  };
};

export const ContextMenuContainer = ({ children, style }: Props) => {
  const [customClass, setCustomClass] = useState<string>('');

  const clearContextMenuState = useEditorStore((state) => state.clearContextMenuState);
  
  const ref = React.useRef<HTMLDivElement>(null);

  useClickAway(ref, () => {
    clearContextMenuState();
  });

  useEffect(() => {
    if (ref.current) {
      const contextBounding = ref.current.getBoundingClientRect();
      const bottomDistance = window.innerHeight - contextBounding.bottom;

      if (bottomDistance < 0) {
        setCustomClass(`max-h-[170px]`);
      }
    }
  }, []);

  return (
    <div className={`fixed z-neue-context-menu h-full overflow-y-auto ${customClass}`} style={style}>
      <div ref={ref} className='w-[248px] rounded-lg bg-neue-journey-bg-90 text-neue-journey-fg p-2 flex flex-col'>
        {children}
      </div>
    </div>
  );
};
